module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 1rem 0",
      "height": "100%"
    }
  }, [_c('van-cell-group', [(false) ? _c('van-cell', {
    attrs: {
      "title": "实名认证",
      "label": "上传身份证信息，完成后自动关联运动员、裁判员、教练员数据"
    },
    scopedSlots: _vm._u([{
      key: "right-icon",
      fn: function() {
        return [_c('div', {
          staticClass: "tiny-btn-1"
        }, [_vm._v("去认证")])]
      },
      proxy: true
    }], null, false, 2704647020)
  }) : _vm._e(), _vm._v(" "), (false) ? _c('van-cell', {
    attrs: {
      "title": "家长认证",
      "label": "上传身份证明信息，完成后自动关联子女运动员信息"
    },
    scopedSlots: _vm._u([{
      key: "right-icon",
      fn: function() {
        return [_c('div', {
          staticClass: "tiny-btn-1"
        }, [_vm._v("管理")])]
      },
      proxy: true
    }], null, false, 589936917)
  }) : _vm._e(), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "单位认证",
      "label": "关联CCA单位信息，完成后可获得单位相关业务权限"
    },
    scopedSlots: _vm._u([{
      key: "right-icon",
      fn: function() {
        return [(_vm.row.danwei.registstatus == 0) ? _c('div', {
          directives: [{
            name: "rblink",
            rawName: "v-rblink",
            value: ({
              name: 'CertDanwei'
            }),
            expression: "{name:'CertDanwei'}"
          }],
          staticClass: "tiny-btn-1"
        }, [_vm._v("去认证")]) : (_vm.row.danwei.registstatus == 3) ? _c('div', {
          directives: [{
            name: "rblink",
            rawName: "v-rblink",
            value: ({
              name: 'CertDanweiResult'
            }),
            expression: "{name:'CertDanweiResult'}"
          }],
          staticClass: "tiny-btn-0"
        }, [_vm._v("认证失败")]) : (_vm.row.danwei.registstatus == 1) ? _c('div', {
          directives: [{
            name: "rblink",
            rawName: "v-rblink",
            value: ({
              name: 'CertDanweiResult'
            }),
            expression: "{name:'CertDanweiResult'}"
          }],
          staticClass: "tiny-btn-0"
        }, [_vm._v("审核中")]) : (_vm.row.danwei.registstatus == 2) ? _c('div', {
          staticClass: "tiny-btn-0",
          on: {
            "click": _vm.unbind
          }
        }, [_vm._v("解除认证")]) : _vm._e(), _vm._v(" "), (_vm.row.danwei_list.length > 1) ? _c('div', {
          staticClass: "tiny-btn-0",
          staticStyle: {
            "position": "absolute",
            "right": "16px",
            "top": "50px"
          },
          on: {
            "click": function($event) {
              _vm.sheetActiveShow = true
            }
          }
        }, [_vm._v("切换单位")]) : _vm._e()]
      },
      proxy: true
    }])
  }), _vm._v(" "), (_vm.row.danwei.registstatus == 2) ? _c('van-cell', {
    attrs: {
      "value": _vm.row.danwei.name
    },
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function() {
        return [_c('van-tag', {
          attrs: {
            "plain": "",
            "type": "success"
          }
        }, [_vm._v("已认证")])]
      },
      proxy: true
    }], null, false, 2624470635)
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bottom-button"
  }, [_c('van-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'YundongyuanList'
      }),
      expression: "{name:'YundongyuanList'}"
    }],
    attrs: {
      "round": "",
      "type": "default"
    }
  }, [_vm._v("运动员管理")]), _vm._v(" "), _c('van-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'CaipanList'
      }),
      expression: "{name:'CaipanList'}"
    }],
    attrs: {
      "round": "",
      "type": "default"
    }
  }, [_vm._v("随队裁判员")]), _vm._v(" "), _c('van-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'JiaolianList'
      }),
      expression: "{name:'JiaolianList'}"
    }],
    attrs: {
      "round": "",
      "type": "default"
    }
  }, [_vm._v("随队教练员")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "10px"
    }
  })], 1), _vm._v(" "), _c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "实名认证",
      "label": "关联实名信息，完成后可获得个人相关业务权限"
    },
    scopedSlots: _vm._u([{
      key: "right-icon",
      fn: function() {
        return [(_vm.row.cert.status == 0) ? _c('div', {
          staticClass: "tiny-btn-1",
          on: {
            "click": function($event) {
              _vm.showNumTypePicker = true
            }
          }
        }, [_vm._v("去认证")]) : (_vm.row.cert.status == 1) ? _c('div', {
          staticClass: "tiny-btn-0",
          on: {
            "click": _vm.unbindPerson
          }
        }, [_vm._v("解除认证")]) : _vm._e()]
      },
      proxy: true
    }])
  }), _vm._v(" "), (_vm.row.cert.status == 1) ? _c('van-cell', {
    attrs: {
      "value": _vm.row.cert.user_name + ' ' + _vm.row.cert.user_code
    },
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function() {
        return [_c('van-tag', {
          attrs: {
            "plain": "",
            "type": "success"
          }
        }, [_vm._v("已实名")])]
      },
      proxy: true
    }], null, false, 1785139229)
  }) : _vm._e(), _vm._v(" "), (_vm.row.cert.status == 1) ? _c('div', {
    staticClass: "bottom-button"
  }, [_c('van-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'UserSearchCaipan'
      }),
      expression: "{name:'UserSearchCaipan'}"
    }],
    attrs: {
      "round": "",
      "type": "default"
    }
  }, [_vm._v("裁判员资质查询")]), _vm._v(" "), _c('van-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'UserSearchJiaolian'
      }),
      expression: "{name:'UserSearchJiaolian'}"
    }],
    attrs: {
      "round": "",
      "type": "default"
    }
  }, [_vm._v("教练员资质查询")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "10px"
    }
  })], 1), _vm._v(" "), _c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "证件照管理",
      "label": "裁判员、教练员等证书照片显示"
    },
    scopedSlots: _vm._u([{
      key: "right-icon",
      fn: function() {
        return [_c('div', {
          directives: [{
            name: "rblink",
            rawName: "v-rblink",
            value: ({
              name: 'CertPersonPhoto'
            }),
            expression: "{name:'CertPersonPhoto'}"
          }],
          staticClass: "tiny-btn-1"
        }, [_vm._v("去管理")]), _vm._v(" "), (_vm.row.photo.status == 2) ? _c('div', {
          directives: [{
            name: "rblink",
            rawName: "v-rblink",
            value: ({
              name: 'CertPersonPhoto'
            }),
            expression: "{name:'CertPersonPhoto'}"
          }],
          staticClass: "tiny-btn-0 green",
          staticStyle: {
            "border": "1px solid #42BD56",
            "margin-left": ".1rem"
          }
        }, [_vm._v("审核成功")]) : _vm._e(), _vm._v(" "), (_vm.row.photo.status == 3) ? _c('div', {
          directives: [{
            name: "rblink",
            rawName: "v-rblink",
            value: ({
              name: 'CertPersonPhoto'
            }),
            expression: "{name:'CertPersonPhoto'}"
          }],
          staticClass: "tiny-btn-0",
          staticStyle: {
            "margin-left": ".1rem"
          }
        }, [_vm._v("审核失败")]) : _vm._e()]
      },
      proxy: true
    }])
  })], 1), _vm._v(" "), (_vm.row.weiyuanhui_list.length > 0) ? _c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "省市管理",
      "label": "管理赛事、会议、七彩星级、俱乐部、大课间等信息"
    },
    scopedSlots: _vm._u([{
      key: "right-icon",
      fn: function() {
        return [_c('div', {
          directives: [{
            name: "rblink",
            rawName: "v-rblink",
            value: ({
              name: 'WeiyuanhuiList'
            }),
            expression: "{name:'WeiyuanhuiList'}"
          }],
          staticClass: "tiny-btn-1"
        }, [_vm._v("去选择")])]
      },
      proxy: true
    }], null, false, 438853264)
  })], 1) : _vm._e(), _vm._v(" "), _c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "区域合伙人管理",
      "label": "个人在所在区域内所有销售业务管理"
    },
    scopedSlots: _vm._u([{
      key: "right-icon",
      fn: function() {
        return [_c('div', {
          staticClass: "tiny-btn-1"
        }, [_vm._v("去选择")])]
      },
      proxy: true
    }])
  })], 1), _vm._v(" "), _c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "个人合伙人管理",
      "label": "个人所有销售业务管理"
    },
    scopedSlots: _vm._u([{
      key: "right-icon",
      fn: function() {
        return [_c('div', {
          staticClass: "tiny-btn-1"
        }, [_vm._v("去管理")])]
      },
      proxy: true
    }])
  })], 1), _vm._v(" "), _c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "省服务专员",
      "label": "所联络的省份的所有销售订单管理"
    },
    scopedSlots: _vm._u([{
      key: "right-icon",
      fn: function() {
        return [_c('div', {
          staticClass: "tiny-btn-1"
        }, [_vm._v("管理订单")])]
      },
      proxy: true
    }])
  })], 1), _vm._v(" "), _c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "公司内部管理",
      "label": "CCA公司内部业务管理：销售订单管理，推荐订单管理"
    },
    scopedSlots: _vm._u([{
      key: "right-icon",
      fn: function() {
        return [_c('div', {
          staticClass: "tiny-btn-1"
        }, [_vm._v("去管理")])]
      },
      proxy: true
    }])
  })], 1), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showNumTypePicker),
      callback: function($$v) {
        _vm.showNumTypePicker = $$v
      },
      expression: "showNumTypePicker"
    }
  }, [_c('van-picker', {
    attrs: {
      "columns": _vm.numTypeColumns,
      "show-toolbar": "",
      "title": "实名验证类型选择"
    },
    on: {
      "cancel": function($event) {
        _vm.showNumTypePicker = false
      },
      "confirm": _vm.onNumTypeConfirm
    }
  })], 1), _vm._v(" "), _c('van-action-sheet', {
    attrs: {
      "description": "将以新的单位为主体参赛报名",
      "actions": _vm.row.danwei_list,
      "cancel-text": "取消",
      "close-on-click-action": ""
    },
    on: {
      "cancel": _vm.onSheetCancel,
      "select": _vm.onSelect
    },
    model: {
      value: (_vm.sheetActiveShow),
      callback: function($$v) {
        _vm.sheetActiveShow = $$v
      },
      expression: "sheetActiveShow"
    }
  }), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50465c2c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/user/cert/CertIndex.vue
// module id = 2389
// module chunks = 0